export enum FeatureDetailsDialog {
  OtherUnderwritersEnable = 'other-underwriters-enable',
  EnableAdditionalServices = 'enable-additional-services',
  OtherUnderwritersDisable = 'other-underwriters-disable',
  DisableConfirm = 'disable-confirm',
}

export enum BannerAction {
  DirectEnable = 'direct-enable',
  OtherUnderwritersEnable = 'other-underwriters-enable',
  OtherUnderwritersDisable = 'other-underwriters-disable',
  DisableConfirm = 'disable-confirm',
}

export const toFeatureDetailsDialog = (action: BannerAction): FeatureDetailsDialog | null => {
  switch (action) {
    case BannerAction.DirectEnable:
      return null;
    case BannerAction.OtherUnderwritersEnable:
      return FeatureDetailsDialog.OtherUnderwritersEnable;
    case BannerAction.OtherUnderwritersDisable:
      return FeatureDetailsDialog.OtherUnderwritersDisable;
    case BannerAction.DisableConfirm:
      return FeatureDetailsDialog.DisableConfirm;
    default:
      return null;
  }
};
